import { callExternalApi, CallResult } from '../callExternalApi';
import { MyOpportunities } from '../../types/advise';

export const fetchMyOpportunities = async (accountId: string): Promise<CallResult<MyOpportunities>> => {
  return callExternalApi<MyOpportunities>({
    url: `api/advise/opportunities?account_id=${encodeURIComponent(accountId)}`,
    method: 'GET',
    headers: { 'content-type': 'application/json' }
  });
};
